import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var baseStyle = defineStyle(function (props) {
    var colorScheme = props.colorScheme, size = props.size, variant = props.variant;
    return {
        textColor: 'white',
        display: 'inline-flex',
        textTransform: 'none!important',
        alignItems: 'center',
        justifyContent: 'center',
        height: size === 'large' ? '40px' : '24px',
        color: 'white',
        bg: colorScheme,
        position: "relative",
        borderRadius: variant === 'round' ? '0px 7px 7px 0px' : '0px 4px 4px 0px;',
        padding: variant === 'round' ? '8px 8px 8px 8px' : '8px 8px 8px 8px;',
        fontSize: size === 'large' ? '16px' : '14px',
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        zIndex: 1,
        _after: {
            content: '""',
            background: "inherit",
            display: "block",
            position: "absolute",
            zIndex: -1,
        },
    };
});
var sharpShapeLarge = defineStyle(function (props) {
    var size = props.size;
    return {
        _after: {
            width: size === 'small' ? '18px' : "30px",
            height: size === 'small' ? '18px' : "30px",
            top: size === 'small' ? "3px" : "5px",
            right: size === 'small' ? "-6px" : "-12px",
            transform: "rotate(135deg)",
            borderRadius: "3px",
            // boxShadow: "0 -3px 2px -2px rgb(32, 34, 35, 42%)",
            zIndex: -1,
        }
    };
});
var roundShapeLarge = defineStyle(function (props) {
    var size = props.size;
    return {
        _after: {
            width: size === 'small' ? "24px" : "49px",
            height: size === 'small' ? "24px" : "40px",
            top: "0px",
            right: size === 'small' ? "-4px" : "-13px",
            borderRadius: size === 'small' ? "30px" : "21px",
            // boxShadow: "0 2px 2px -2px rgb(99 100 101 / 30%)",
            zIndex: -1,
        }
    };
});
var badgeTheme = defineStyleConfig({
    baseStyle: baseStyle,
    variants: {
        sharp: sharpShapeLarge,
        round: roundShapeLarge
    },
    defaultProps: {
        variant: 'sharp',
        size: 'large',
        colorScheme: 'secondary.600',
    }
});

export { badgeTheme };
//# sourceMappingURL=badge.js.map
